import Layout from '@/layout/index'

// 动态路由映射表
const routeMap = {
  'system': null,   // 目录
  'home': () => import('@/views/home/index'),
  'user:list': () => import('@/views/user/index'),
  'role:list': () => import('@/views/role/index'),
  'menu:list': () => import('@/views/menu/index'),
  'store:list': () => import('@/views/store/index'),
  'points:list': () => import('@/views/points/index'),
  'points:rule': () => import('@/views/points/rule'),
  'points:withdraw': () => import('@/views/points/withdraw'),
  'log:operation': () => import('@/views/log/operation'),
  'log:login': () => import('@/views/log/login'),
  'system:config': () => import('@/views/system/config')
}

const state = {
  routes: []
}

const mutations = {
  SET_ROUTES: (state, routes) => { state.routes = routes }
}

const actions = {
  generateRoutes({ commit }, menus) {
    const accessedRoutes = filterAsyncRoutes(menus)
    commit('SET_ROUTES', accessedRoutes)
    return Promise.resolve(accessedRoutes)
  }
}

function filterAsyncRoutes(menus) {
  const children = []
  menus.forEach(menu => {
    if (menu.type === 'M') {
      // 目录 — 遍历子菜单
      if (menu.children) {
        menu.children.forEach(child => {
          const route = menuToRoute(child)
          if (route) children.push(route)
        })
      }
    } else if (menu.type === 'C') {
      // 菜单
      const route = menuToRoute(menu)
      if (route) children.push(route)
    }
  })
  // 包裹在 Layout 路由下，保持 sidebar + header
  return [{
    path: '/',
    component: Layout,
    children
  }]
}

function menuToRoute(menu) {
  const component = routeMap[menu.permissionCode] || Layout
  // 去掉路径前面的 /，作为 Layout 的子路由
  const path = menu.path ? menu.path.replace(/^\//, '') : menu.path
  return {
    path,
    component,
    meta: { title: menu.name, icon: menu.icon, permission: menu.permissionCode }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
